import { MagicConfigMixin, ModalMixin, SessionChange } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { importResponsibleGaming } from '../../../utils/helpers.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let ConfirmationPrompterComponent = class extends Mixins(MagicConfigMixin, ModalMixin) {
  constructor() {
    super(...arguments);
    this.isLoading = false;
  }
  render() {
    return null;
  }
  sessionChange(isLoggedIn) {
    if (isLoggedIn) {
      this.fetchLimits();
      return;
    }
    this.closeModal();
  }
  fetchLimits() {
    return __async(this, null, function* () {
      const isPepBlocked = yield window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY);
      if (isPepBlocked) {
        return;
      }
      const awaiting = yield magic.invokeCached(60, magic.methods.responsibleGaming, "awaitingUserLimitsConfirmation")();
      if (awaiting.length > 0 && !this.hasModal()) {
        yield importResponsibleGaming();
        const modalElement = this.openModal(this.renderedModal, this.header || null, {
          dismissible: false,
          keepAfterClear: true
        });
        modalElement.addEventListener("confirmed", () => {
          this.closeModal();
        });
        modalElement.unconfirmedLimits = awaiting;
      }
    });
  }
};
__decorateClass([
  Prop({
    type: String,
    default: "magic-limit-confirmation-prompt"
  })
], ConfirmationPrompterComponent.prototype, "renderedModal", 2);
__decorateClass([
  Prop({
    type: String,
    default: null
  })
], ConfirmationPrompterComponent.prototype, "header", 2);
__decorateClass([
  SessionChange({ immediate: true })
], ConfirmationPrompterComponent.prototype, "sessionChange", 1);
ConfirmationPrompterComponent = __decorateClass([
  Component({
    name: "limit-confirmation-prompter"
  })
], ConfirmationPrompterComponent);

export default ConfirmationPrompterComponent;
